/*
 * @Descripttion: 表格的tab键 enter键 上下左右键
 * @version: 
 * @Author: bbq
 * @Date: 2020-09-05 09:49:57
 * @LastEditors: bbqin
 * @LastEditTime: 2021-11-23 14:37:35
 */

import React, { Component } from 'react';
import { ViewModel, isFunction, isArray, isArrowKeyDown } from '@platform/api';
import { WithKeyboardChange, WithAutoFocus } from '@platform/base';
import { findParentTd, config as CONFIG } from '@platform/api';

const { TableWithAutoFocus } = WithAutoFocus;
const { findNextFocusItemInTable, EditTableWithKeyboardChange, TableWithKeyboardChange, ARROW_KEY } = WithKeyboardChange;

import './index.less';
/**
* 快捷键逻辑处理
* @param {*} Table 
*/
export default function hotkey(Table, componentParams) {

    if (!Table) {
        console.error('缺少Table组件');
    }

    class MetaTable extends Component {
        constructor(props) {
            super(props);
            this.times = null;
        }

        // click
        handleTableCellClick(record, index, attrcode, col, e) {
            this.mousedown = false;
            return true;
        }

        // cell 点击时
        handleCellMouseDown(record, index, attrcode, col, e) {
            this.mousedown = true;
            return true;
        }

        // 获取对应单元格的数据
        getCellIdentity = dom => {
            if (!dom) {
                console.log('not find td dom');
                return {};
            }
            let item = dom.getAttribute('cellselectorkey')
            const keys = item.split('@');
            if (keys.length < 2) {
                console.warn('缺少一部分key')
                return {};
            }
            return {
                rowKeyValue: keys[0],
                attrcode: keys[1],
            };
        }

        // 找到首项
        findFirstTdInRow = tr => {
            let tds = tr.querySelectorAll('td');

            let td = Array.prototype.find.call(tds, function (td) {
                return !td.className.includes('fixed');
            });

            return td;
        }

        // 找到前一项
        findPrevTd = (parentTd, result = {}) => {
            let prevTd = parentTd.previousElementSibling;
            let currentTr = parentTd.parentElement;
            let firstTd = this.findFirstTdInRow(currentTr);
            let lastTd = this.findLastTdInRow(currentTr);
            let div = prevTd && prevTd.querySelector('div.table-cell-wrapper[cellselectorkey]'); // 多限定下 为了下面的聚焦使用

            // 如果递归了一遍发现还是自己  停止递归
            if (this.times === prevTd && !!this.times) {
                return {};
            }
            // 只记录第一次
            this.times = this.times || prevTd;

            // 防止只有一个单元格反复横跳 出现问题
            if (lastTd === firstTd) {
                let prevTr = currentTr.previousElementSibling;
                let prevTd = prevTr && prevTr.querySelector('td:last-child');
                return this.findPrevTd(prevTd, result);
            }

            // 首项
            if (firstTd === parentTd) {
                let firstTr = currentTr.parentElement.firstElementChild;
                let prevTr = currentTr.previousElementSibling;
                // 首行
                if (currentTr === firstTr) {
                    prevTr = currentTr.parentElement.lastElementChild;
                    return {};
                }
                let lastTd = prevTr && prevTr.querySelector('td:last-child');
                let lastDiv = lastTd && lastTd.querySelector('div.table-cell-wrapper[cellselectorkey]'); // 多限定下 为了下面的聚焦使用

                if (lastDiv) {
                    return { nextTd: this.getCellIdentity(lastDiv), nextDom: lastDiv };
                }
                return this.findPrevTd(lastTd, result);
                // return {};
            }

            // 如果下一个元素没有找到就继续查找
            if (div === null) {
                return this.findPrevTd(prevTd, result);
            }

            // 聚焦一下 让焦点到下个元素上
            return { nextTd: this.getCellIdentity(div), nextDom: div };
        }

        // 找到末项
        findLastTdInRow = tr => {
            let td = tr.lastElementChild.className.includes('fixed')
                ? tr.lastElementChild.previousElementSibling
                : tr.lastElementChild;

            return td;
        }

        // 找到下一项
        findNextTd = (parentTd, result = {}) => {
            let nextTd = parentTd.nextElementSibling;
            let currentTr = parentTd.parentElement;
            let firstTd = this.findFirstTdInRow(currentTr);
            let lastTd = this.findLastTdInRow(currentTr);
            let div = nextTd && nextTd.querySelector('div.table-cell-wrapper[cellselectorkey]'); // 多限定下 为了下面的聚焦使用

            // 如果递归了一遍发现还是自己  停止递归
            if (this.times === nextTd && !!this.times) {
                return {};
            }
            // 只记录第一次
            this.times = this.times || nextTd;

            // 防止只有一个单元格反复横跳 出现问题
            if (lastTd === firstTd) {
                let nextTr = currentTr.nextElementSibling;
                let nextTd = nextTr && nextTr.querySelector('td:first-child');
                return this.findNextTd(nextTd, result);
            }

            // 末项
            if (lastTd === parentTd) {
                let lastTr = currentTr.parentElement.lastElementChild;
                let nextTr = currentTr.nextElementSibling;
                // 末行
                if (currentTr === lastTr) {
                    nextTr = currentTr.parentElement.firstElementChild;
                    return {};
                }
                let firstTd = nextTr && nextTr.querySelector('td:first-child');
                let firstDiv = firstTd && firstTd.querySelector('div.table-cell-wrapper[cellselectorkey]'); // 多限定下 为了下面的聚焦使用

                if (firstDiv) {
                    return { nextTd: this.getCellIdentity(firstDiv), nextDom: firstDiv };
                }
                return this.findNextTd(firstTd, result);
                // return {};
            }

            // 如果下一个元素没有找到就继续查找
            if (div === null) {
                return this.findNextTd(nextTd, result);
            }

            // 聚焦一下 让焦点到下个元素上
            return { nextTd: this.getCellIdentity(div), nextDom: div };
        }

        // 找到高山流水
        findUpTd = (parentTd, result = {}, attrcode) => {

            let currentTr = parentTd.parentElement;
            let firstTr = currentTr.parentElement.querySelector('tr:first-child');
            let lastTr = currentTr.parentElement.querySelector('tr:last-child');

            // 当前div
            let currentDiv = parentTd && parentTd.querySelector('div.table-cell-wrapper[cellselectorkey]');
            // 记录初始的attrcode
            attrcode = attrcode || this.getCellIdentity(currentDiv).attrcode;

            // 取出上一行的rowKeyValue
            let upTr = currentTr.previousElementSibling;
            // 随便一个元素
            let upTrDiv = upTr && upTr.querySelector('div.table-cell-wrapper[cellselectorkey]');
            let { rowKeyValue } = this.getCellIdentity(upTrDiv);

            // 如果递归了一遍发现还是自己  停止递归
            if (this.times === upTr && !!this.times) {
                return {};
            }
            // 只记录第一次
            this.times = this.times || upTr;


            // 首项
            if (currentTr === firstTr) {
                // 随便一个元素
                let lastTd = lastTr && lastTr.querySelector('td');
                // return this.findUpTd(lastTd, result, attrcode);
                return {};
            }

            // 防止只有一个单元格反复横跳 出现问题
            if (upTrDiv === null) {
                let upTr = currentTr.previousElementSibling;
                // 随便一个元素
                let upTd = upTr && upTr.querySelector('td');
                return this.findUpTd(upTd, result, attrcode);
            }

            // 聚焦一下 让焦点到下个元素上
            return { nextTd: { attrcode, rowKeyValue }, nextDom: upTr.querySelector(`div.table-cell-wrapper[cellselectorkey="${rowKeyValue}@${attrcode}"]`) };
        }

        // 找到下里巴人
        findDownTd = (parentTd, result = {}, attrcode) => {
            let currentTr = parentTd.parentElement;
            let firstTr = currentTr.parentElement.querySelector('tr:first-child');
            let lastTr = currentTr.parentElement.querySelector('tr:last-child');

            // 当前div
            let currentDiv = parentTd && parentTd.querySelector('div.table-cell-wrapper[cellselectorkey]');
            // 记录初始的attrcode
            attrcode = attrcode || this.getCellIdentity(currentDiv).attrcode;

            // 取出上一行的rowKeyValue
            let downTr = currentTr.nextElementSibling;
            // 随便一个元素
            let downTrDiv = downTr && downTr.querySelector('div.table-cell-wrapper[cellselectorkey]');
            let { rowKeyValue } = this.getCellIdentity(downTrDiv);

            // 如果递归了一遍发现还是自己  停止递归
            if (this.times === downTr && !!this.times) {
                return {};
            }
            // 只记录第一次
            this.times = this.times || downTr;


            // 末项
            if (currentTr === lastTr) {
                // 随便一个元素
                let lastTd = lastTr && lastTr.querySelector('td');
                return {};
            }

            // 防止只有一个单元格反复横跳 出现问题
            if (downTrDiv === null) {
                let downTr = currentTr.nextElementSibling;
                // 随便一个元素
                let upTd = downTr && downTr.querySelector('td');
                return this.findDownTd(upTd, result, attrcode);
            }

            // 聚焦一下 让焦点到下个元素上
            return { nextTd: { attrcode, rowKeyValue }, nextDom: downTr.querySelector(`div.table-cell-wrapper[cellselectorkey="${rowKeyValue}@${attrcode}"]`) };
        }

        render() {
            let {
                rowKey,
                onCellMouseDown,
                onCellFocus,
                onCellKeyDown,
                onTableCellClick,
                onEnter,
                hotKeyWithArrow,
                hotKeyWithEnter,
                high_hotkey,
                ...others
            } = this.props;
            const { store, activeCell, tableId, enaable = true, browse, spaceKeyDown, autoFocus = true } = high_hotkey;
            return <Table
                onCellMouseDown={(record, index, attrcode, col, e) => {
                    let res = onCellMouseDown ? onCellMouseDown(record, index, attrcode, col, e) : true;
                    return res !== false && this.handleCellMouseDown(record, index, attrcode, col, e);
                }}
                onCellFocus={(record, index, attrcode, col, e) => {
                    let res = onCellFocus ? onCellFocus(record, index, attrcode, col, e) : true;
                }}
                onCellKeyDown={(record, index, attrcode, col, e) => {
                    // space 触发回调
                    if (e.keyCode === 32 && browse === 'browse') {
                        e.stopPropagation();
                        e.preventDefault();
                        spaceKeyDown && spaceKeyDown(record, index, attrcode, col, e);
                    }
                    let res = onCellKeyDown ? onCellKeyDown(record, index, attrcode, col, e) : true;
                }}
                onTableCellClick={(record, index, attrcode, col, e) => {
                    let res = onTableCellClick ? onTableCellClick(record, index, attrcode, col, e) : true;
                    return res !== false && this.handleTableCellClick(record, index, attrcode, col, e);
                }}
                onEnter={({ e, target = undefined, itemType }) => {
                    hotKeyWithEnter({ e, ViewModel, moduleId: tableId, target, itemType: itemType });
                }}
                hotKeyWithArrow={({ e, target = undefined, itemType, browse }) => {
                    console.log(browse);
                    if (!browse) {
                        hotKeyWithArrow({ e, ViewModel, moduleId: tableId, target, itemType: itemType });
                    } else {
                        e.preventDefault();
                        e.stopPropagation();
                        let eventTarget = target || e.target;
                        let parentTd = eventTarget.tagName === 'TD' ? eventTarget : findParentTd(eventTarget);
                        let nextTd = null;
                        let nextDom = null;
                        let result = null;
                        this.times = null;
                        switch (e.keyCode) {
                            case 37:
                                // left
                                result = this.findPrevTd(parentTd);
                                nextTd = result.nextTd;
                                nextDom = result.nextDom;
                                break;
                            case 38:
                                // up 
                                result = this.findUpTd(parentTd);
                                nextTd = result.nextTd;
                                nextDom = result.nextDom;
                                break;
                            case 39:
                                // right
                                result = this.findNextTd(parentTd);
                                nextTd = result.nextTd;
                                nextDom = result.nextDom;
                                break;
                            case 40:
                                // down
                                result = this.findDownTd(parentTd);
                                nextTd = result.nextTd;
                                nextDom = result.nextDom;
                                break;
                            default:
                                break;
                        }
                        if (!nextDom || !nextTd) {
                            return;
                        }
                        let prevTd = this.getCellIdentity(parentTd && parentTd.querySelector('div[cellselectorkey]'));
                        // console.log(nextTd, prevTd, nextDom);
                        nextTd && activeCell(nextTd, prevTd, nextDom);
                    }
                }}
                rowKey={rowKey}
                {...others}
            />
        }
    }

    // 自动聚焦
    // MetaTable = TableWithAutoFocus(MetaTable);
    // 上下键 enter键
    // console.log(componentParams);
    const { name, type, user } = componentParams;
    if (name === 'simpleTable') {
        return MetaTable;
    }
    return TableWithAutoFocus(name === 'editTable' ? EditTableWithKeyboardChange(MetaTable) : TableWithKeyboardChange(MetaTable));
}